// @ts-nocheck
/* eslint-disable */
import { CSSProperties } from 'react';
import { css } from 'emotion';
import cx from 'classnames';
import THEME from '../shared/theme';

const globalStyles = {};

interface CustomCSSProperties extends CSSProperties {
  ':hover'?: React.CSSProperties;
}

interface StyleDefinition {
  [key: string]: CustomCSSProperties;
}

export function cssInJS<T>(styles: StyleDefinition): T {
  const object = {};

  for (const property in styles) {
    const styleObject = styles[property];

    object[property] = css(styleObject);

    globalStyles[object[property]] = object[property];
  }

  return object;
}

window.cssInJS = cssInJS;
window.css = cx;
window.STYLES = globalStyles;
window.THEME = THEME;
/* eslint-enable */
